export default __webpack_public_path__ + "static/media/marc-olivier-jodoin-tauPAnOIGvE-unsplash.09dde251.jpg";